import secureStorageInstance from"../secureStorage";export default secureStorageInstance;